

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import ActionReloader from '~common-components/Popup/Common/ActionReloader.vue';
import { DevicesModule } from '~/store/modules/devices';
import { TimelineEvent } from '~/interfaces/device.interface';
import { humanReadableField } from '~/filters/humanReadableField';
import { humanReadableDate } from '~common-filters/humanReadableDate';
import ContentFilter from '~common-components/Popup/Common/ContentFilter.vue';
import { PopupModule } from '~common-store/modules/popup';
import { valueIncludesFilterValue } from '~/helpers';

@Component({
    components: {
        ActionReloader,
        ContentFilter,
    },
})
export default class OperationTimeline extends Mixins(PopupMixin) {
    get currentGatewayId() {
        return DevicesModule.currentGatewayId;
    }
    async getTimeline() {
        try {
            const data = await DevicesModule.currentGateway?.timeline();
            await DevicesModule.setTimelineEvents(data || []);
        } catch (error) {
            await DevicesModule.setTimelineEvents([]);
        }
    }

    get formattedTimeline() {
        const timeline = JSON.parse(JSON.stringify(this.sortedEvents)) as TimelineEvent[];
        return timeline
            .map((event, index) => {
                return {
                    ...event,
                    type: humanReadableField(event.type),
                    time: humanReadableDate(event.time, 'full'),
                    duration: this.duration(timeline, index),
                };
            })
            // filter values based on our filter value and whether we include or exclude the value we put
            .filter((event) => {
                if (!PopupModule.filterValue) {
                    return true;
                }
                // remove values that are not stringifiable with .toString()
                const values = Object.values(event).filter((value) => typeof value !== 'object');
                return PopupModule.filterIncludesValue
                    ? values.some(valueIncludesFilterValue)
                    : values.every((value) => !valueIncludesFilterValue(value));
            });
    }

    get timelineEvents() {
        return DevicesModule.timelineEvents;
    }

    get sortedEvents()  {
        const events = JSON.parse(JSON.stringify(this.timelineEvents)) as TimelineEvent[];
        const sessionsId = [] as string[];
        const colors: { [key: string]: string } = {};

        events.forEach((event, index) => {
            if (event.session_id) {
                sessionsId.push(event.session_id);
            }
            if (event.type === 'sd') {
                events[index].type = 'sd_' + event.sub_type;
            }
        });

        sessionsId.forEach((sessionId) => {
            colors[sessionId] = '#' + Math.floor(Math.random() * 0xffffff).toString(16);
        });

        events.forEach((event) => {
            if (event.session_id) {
                event.color = colors[event.session_id];
            }
        });
        return events;
    }

    duration(timeline: TimelineEvent[], index: number) {
        if (
            index >= timeline.length
            || (timeline[index].type !== 'disconnection' && timeline[index].type !== 'connection')
        ) {
            return '';
        }

        const t1 = timeline[index].time;
        let t2 = null;
        if (timeline[index].type === 'disconnection') {
            // Find the associated connection
            for (let i = index + 1; i < timeline.length; i++) {
                if (
                    timeline[i].type === 'connection'
                    && timeline[i]?.session_id === timeline[index].session_id
                ) {
                    t2 = timeline[i].time;
                    break;
                }
            }
        } else {
            // Find the previous disconnection
            for (let i = index + 1; i < timeline.length; i++) {
                if (timeline[i].type === 'disconnection') {
                    t2 = timeline[i].time;
                    break;
                }
            }
        }
        if (t2 === null) {
            return;
        }
        const duration = Math.abs(t2 - t1);
        const oneHour = 60 * 60;
        const oneMinute = 60;
        const hours = Math.floor(duration / oneHour);
        const minutes = Math.floor((duration - (hours * oneHour)) / oneMinute);
        const seconds = Math.floor(duration - (hours * oneHour) - (minutes * oneMinute));

        return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    }
}
